import { render, staticRenderFns } from "./Day18.vue?vue&type=template&id=033a0220"
import script from "./Day18.vue?vue&type=script&lang=js"
export * from "./Day18.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports